export const LIST_ROW_HEIGHTS = {
  stickyHeader: 30,
  large: 80,
  normal: 60,
};
